import { createAction, createReducer, Dispatch } from '@reduxjs/toolkit';
import { AutolistUser } from 'types/User';
import captureException from 'lib/captureException';
import { fetchUser } from 'lib/AutolistAPI';

export const fetchAutolistUserStart = createAction('user/fetchUser/start');
export const fetchAutolistUserSuccess = createAction<AutolistUser>('user/fetchUser/success');
export const fetchAutolistUserFailure = createAction<Error>('user/fetchUser/failure');

export function fetchAutolistUser() {
  return async function autolistUserFetcher(dispatch: Dispatch): Promise<void> {
    dispatch(fetchAutolistUserStart());
    try {
      const user = await fetchUser();
      dispatch(fetchAutolistUserSuccess(user));
    } catch (e) {
      dispatch(fetchAutolistUserFailure(e));
      captureException(e);
    }
  };
}

export const userReducer = createReducer(
  {},
  {
    [fetchAutolistUserSuccess.type]: (state, action) => {
      return action.payload;
    },
  }
);
